export default __webpack_public_path__ + "static/media/trr-food-handheld-southwestveggiewrap.faad8afb.png";